const toFiniteNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const buildAutocompleteOfferPriceMap = (payload) => {
  const items = Array.isArray(payload?.items) ? payload.items : [];

  return items.reduce((accumulator, item) => {
    const itemId = item?.necessity_list_item_id;
    const lowestHistoricalOfferPrice = toFiniteNumber(item?.lowest_historical_offer_price);

    if (!itemId || lowestHistoricalOfferPrice === null || lowestHistoricalOfferPrice <= 0) {
      return accumulator;
    }

    accumulator[String(itemId)] = lowestHistoricalOfferPrice;
    return accumulator;
  }, {});
};

export const mergeAutocompletePricesIntoOfferInputs = (products, previousOfferPrices, autocompletePriceMap) => {
  const normalizedProducts = Array.isArray(products) ? products : [];
  const nextOfferPrices = { ...(previousOfferPrices || {}) };
  let changed = false;

  normalizedProducts.forEach((product) => {
    const productKey = product?.key;
    const itemId = product?.originalData?.id;
    const autocompletePrice = itemId ? autocompletePriceMap?.[String(itemId)] : null;
    const currentPrice = nextOfferPrices[productKey];
    const hasManualValue = currentPrice !== undefined && currentPrice !== null && String(currentPrice).trim() !== '';

    if (!productKey || autocompletePrice === null || hasManualValue) {
      return;
    }

    nextOfferPrices[productKey] = autocompletePrice;
    changed = true;
  });

  return changed ? nextOfferPrices : previousOfferPrices;
};
